import { render } from "./ActivityFeed.vue?vue&type=template&id=0aa51a16"
import script from "./ActivityFeed.vue?vue&type=script&lang=js"
export * from "./ActivityFeed.vue?vue&type=script&lang=js"

import "./ActivityFeed.vue?vue&type=style&index=0&id=0aa51a16&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__